<template>
  <div>
     <client-form-search
      v-model='value.owner'
      label='Owner'
      @loading='setLoading'
      :quickpicks='quickpicks'
      @updateQuickpicks='updateQuickpicks'
    ></client-form-search>

    <client-form-search
      v-model='value.bill_to'
      label='Billing Contact'
      @loading='setLoading'
      :quickpicks='quickpicks'
      @updateQuickpicks='updateQuickpicks'
      :hint='value.bill_to ? "" : "required for invoicing"'
    ></client-form-search>

    <client-form-search
      v-model='value.notices_contact'
      label='Notices Contact'
      @loading='setLoading'
      :quickpicks='quickpicks'
      @updateQuickpicks='updateQuickpicks'
      :hint='value.notices_contact ? "" : "required for email"'
    ></client-form-search>

    <div v-if='value.division_obj.division == "Irrigation"'>
      <client-form-search
        v-model='value.sales_contact'
        label='Sales Contact'
        @loading='setLoading'
        :quickpicks='quickpicks'
        @updateQuickpicks='updateQuickpicks'
        :hint='value.sales_contact ? "" : ""'
      ></client-form-search>

      <client-form-search
        v-model='value.install_contact'
        label='Install Contact'
        @loading='setLoading'
        :quickpicks='quickpicks'
        @updateQuickpicks='updateQuickpicks'
        :hint='value.install_contact ? "" : ""'
      ></client-form-search>

      <client-form-search
        v-model='value.site_contact'
        label='Primary Service Contact'
        @loading='setLoading'
        :quickpicks='quickpicks'
        @updateQuickpicks='updateQuickpicks'
        :hint='value.site_contact ? "" : ""'
      ></client-form-search>

      <v-expand-transition>
        <client-form-search
          v-if='value.site_contact || value.secondary_site_contact'
          v-model='value.secondary_site_contact'
          label='Secondary Service Contact'
          @loading='setLoading'
          :quickpicks='quickpicks'
          @updateQuickpicks='updateQuickpicks'
          :hint='value.secondary_site_contact ? "" : "(if required)"'
        ></client-form-search>
      </v-expand-transition>
    </div>

    <div v-else>
      <client-form-search
        v-model='value.site_contact'
        label='Site Contact'
        @loading='setLoading'
        :quickpicks='quickpicks'
        @updateQuickpicks='updateQuickpicks'
        :hint='value.site_contact ? "" : "(optional - if different from owner)"'
      ></client-form-search>

      <v-expand-transition>
        <client-form-search
          v-if='value.site_contact || value.secondary_site_contact'
          v-model='value.secondary_site_contact'
          label='Secondary Site Contact'
          @loading='setLoading'
          :quickpicks='quickpicks'
          @updateQuickpicks='updateQuickpicks'
          :hint='value.secondary_site_contact ? "" : "(if required)"'
        ></client-form-search>
      </v-expand-transition>
    </div>
    
  </div>
</template>

<script>
import _ from 'lodash'
// import miscServices from '@/services/misc'
import formRules from '@/mixins/formRules'
import ClientFormSearch from '@/modules/clients/components/ClientFormSearch'

export default {
  name: 'contacts-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    },
    newContacts: {
      required: true
    }
  },
  data: () => ({
    selections: []
  }),
  computed: {
    // project model contains the following fields:
    // owner
    // bill_to
    // install_contact
    // notices_contact
    // sales_contact
    // site_contact
    // secondary_site_contact
    // service_contact
    // secondary_service_contact
    
    quickpicks() {
      let arr = this.selections
      // MJError - can be a little cleaner here with a forEach - put the contacts array in the data above
      if (this.value.owner_obj && !_.find(this.selections, s => s.id == this.value.owner_obj.id)) {
        arr.push(this.value.owner_obj)
      }
      if (this.value.bill_to_obj && !_.find(this.selections, s => s.id == this.value.bill_to_obj.id)) {
        arr.push(this.value.bill_to_obj)
      }
      if (this.value.notices_contact_obj && !_.find(this.selections, s => s.id == this.value.notices_contact_obj.id)) {
        arr.push(this.value.notices_contact_obj)
      }
      if (this.value.site_contact_obj && !_.find(this.selections, s => s.id == this.value.site_contact_obj.id)) {
        arr.push(this.value.site_contact_obj)
      }
      if (this.value.secondary_site_contact_obj && !_.find(this.selections, s => s.id == this.value.secondary_site_contact_obj.id)) {
        arr.push(this.value.secondary_site_contact_obj)
      }
      if (this.value.sales_contact_obj && !_.find(this.selections, s => s.id == this.value.sales_contact_obj.id)) {
        arr.push(this.value.sales_contact_obj)
      }
      if (this.value.install_contact_obj && !_.find(this.selections, s => s.id == this.value.install_contact_obj.id)) {
        arr.push(this.value.install_contact_obj)
      }
      if (this.newContacts.length) {
        arr.push(...this.newContacts)
      }
      return arr
    }
  },
  methods: {
    setLoading (val) {
      this.$emit('loading', val)
    },
    updateQuickpicks(selected) {
      if (selected && !_.find(this.selections, s => s.id == selected.id)) {
        this.selections.push(selected)
      }
    }
  },
  components: {
    'client-form-search': ClientFormSearch
  }
}
</script>
